import { useContext } from 'react'
import {
  AllowFloatKeys,
  CheckboxSpecs,
  FilterMenus,
  FilterTypes,
  getOperatorName,
} from 'features/dashboard/filter/FilterSpecs'
import TextInput from 'components/form/TextInput'
import { produce } from 'immer'
import CurrencyInput from 'components/form/CurrencyInput'
import SelectBox from 'components/form/SelectBox'
import CheckBox from 'components/form/CheckBox'
import { FilterContext } from 'features/dashboard/filter/FilterContext'
import { addFilter } from 'features/dashboard/filter/dashboardFilterSlice'
import { batch, useDispatch } from 'react-redux'
import { campaignTableActions } from 'features/dashboard/table/campaign/campaignTableSlice'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { keywordTableActions } from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'
import { MetricIds } from '../../../Columns'

const InputForm = () => {
  const dispatch = useDispatch()
  const { filterForm, setFilterForm, hideFilterFormLayer } =
    useContext(FilterContext)
  const { domain, key, data } = filterForm
  const {
    filterType,
    filterType: { operators },
  } = FilterMenus[domain].subs.find(sub => sub.key === key)
  const isMetric = MetricIds.includes(key)
  const allowFloat = AllowFloatKeys.includes(key)
  const handleIdChange = value => {
    const strip = value
      .replace(/[^\d,]/g, '')
      .replace(/\s/g, '')
      .replace(/^,/g, '')
      .replace(/,{2,}/g, ',')
    const splits = strip.split(',').slice(0, 10)
    if (splits.some(v => v.length > 18)) return
    setFilterForm(
      produce(draft => {
        draft.data.value = splits.join(',')
      })
    )
  }
  return (
    <form
      autoComplete="off"
      onSubmit={event => {
        event.preventDefault()
        if (data.value.trim() !== '') {
          batch(() => {
            dispatch(addFilter(filterForm))
            dispatch(campaignTableActions.setPage(0))
            dispatch(adGroupTableActions.setPage(0))
            dispatch(keywordTableActions.setPage(0))
            dispatch(creativeTableActions.setPage(0))
          })
          hideFilterFormLayer()
        }
      }}>
      {filterType === FilterTypes.ID ? (
        <TextInput
          placeholder="콤마(,)로 구분하여 입력하세요. (최대 10개)"
          value={data.value}
          onValueChange={handleIdChange}
        />
      ) : (
        <div className="group_numinp">
          {filterType === FilterTypes.TEXT ? (
            <TextInput
              placeholder="50자 까지 입력 가능합니다."
              className="box_inptxt reform_inp_num"
              maxLength={50}
              value={data.value}
              onValueChange={v =>
                setFilterForm(
                  produce(draft => {
                    draft.data.value = v
                  })
                )
              }
            />
          ) : (
            <CurrencyInput
              placeholder="숫자를 입력하세요."
              integer={!allowFloat}
              typeVisible={false}
              className="box_inptxt reform_inp_num"
              maxLength={isMetric ? 12 : 8}
              max={99999999}
              min={0}
              step={allowFloat ? 'any' : 1}
              value={data.value}
              onValueChange={v =>
                setFilterForm(
                  produce(draft => {
                    const parsed = allowFloat
                      ? Number(v)
                      : Number.parseInt(v, 10)
                    draft.data.value = v === '' || isNaN(parsed) ? '' : v
                  })
                )
              }
            />
          )}

          {operators && (
            <SelectBox
              noBlurOnDefault
              value={data.operator}
              onValueChange={v =>
                setFilterForm(
                  produce(draft => {
                    draft.data.operator = v
                  })
                )
              }>
              {operators.map(operator => (
                <SelectBox.Item key={operator.key} value={operator.key}>
                  {getOperatorName(operator, filterType)}
                </SelectBox.Item>
              ))}
            </SelectBox>
          )}
        </div>
      )}
      {filterType === FilterTypes.MULTI && (
        <CheckBox
          label={CheckboxSpecs[key].text}
          checked={data.checked}
          onCheckedChange={v =>
            setFilterForm(
              produce(draft => {
                draft.data.checked = v
              })
            )
          }
        />
      )}
    </form>
  )
}
export default InputForm
